/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AnalyticsModule
 */

import {
    Component,
    Input,
} from '@angular/core';

import { IEndToEndKnot } from '../../types';
import './end-to-end.component.less';

/**
 * @description List of End to end card with metric values / icons.
 * @author Deepak Chaudhary
 */

@Component({
    selector: 'end-to-end',
    templateUrl: './end-to-end.component.html',
})
export class EndToEndComponent {
    /**
     * End to end card title.
     */
    @Input()
    public cardTitle: string;

    /**
     * List of end to end list with metric values or icons.
     */
    @Input()
    public endToEndList: IEndToEndKnot[];

    public isExpanded = true;

    /**
     * Enable / Disable expand as per screen resize. As on smaller screen, we will
     * always display non exapndable screen.
     */
    public canExpand = true;

    /**
     * Handle toggle for expander.
     */
    public toggleExpanded(): void {
        this.isExpanded = !this.isExpanded;
    }

    /**
     * trackBy Index Method.
     */
    public trackByIndex(index: number): number {
        return index;
    }
}
